import React from "react";
import Header from "../components/layouts/Header/Header";
import Footer from "../components/layouts/Footer/Footer";
// import Registration from "../components/Home/Registration/Registration"; // Ganti ini
import { Helmet } from "react-helmet";
import DonationForm from "../components/Donate/DonationForm";

const DonatePage = () => {
    return (
        <>
            <Helmet>
                <title>Donasi - Surosowan Siber</title>
                <meta
                    name="keywords"
                    content="Information Technology Foundation, Community, Network, Web Development, Full-Stack Developer, Donasi"
                />
                <meta name="author" content="Surosowan Siber Foundation" />
                <meta image="https://surosowancyber.or.id/images/logo/header-logo.png" />

                <meta
                    property="og:url"
                    content="https://surosowancyber.or.id/donate"
                />
                <meta property="og:type" content="foundation" />
                <meta property="og:title" content="Surosowan Siber Foundation" />
                <meta
                    property="og:description"
                    content="Surosowan Siber adalah tempat bagi mereka yang tertarik dengan Teknologi dan tempat untuk berbagi dan belajar"
                />
                <meta property="og:site_name" content="Surosowan Siber Foundation" />
                <meta
                    property="og:image"
                    content="https://surosowancyber.or.id/static/media/header-logo.b2a202d07990d1ffa20c.png"
                />
                <link
                    rel="canonical"
                    href="https://surosowancyber.or.id/donate"
                />
            </Helmet>
            <Header></Header>

            {/* Ganti <Registration> dengan <DonationForm> */}
            <DonationForm />

            <Footer></Footer>
        </>
    );
};

export default DonatePage;